function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHtml(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    className: "Icon ",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "BrowserWithCodeIconClipPath-"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 2C1.79086 2 0 3.79086 0 6V26C0 28.2091 1.79086 30 4 30H32C34.2091 30 36 28.2091 36 26V6C36 3.79086 34.2091 2 32 2H4ZM4.5 8C5.32843 8 6 7.32843 6 6.5C6 5.67157 5.32843 5 4.5 5C3.67157 5 3 5.67157 3 6.5C3 7.32843 3.67157 8 4.5 8ZM11 6.5C11 7.32843 10.3284 8 9.5 8C8.67157 8 8 7.32843 8 6.5C8 5.67157 8.67157 5 9.5 5C10.3284 5 11 5.67157 11 6.5ZM14.5 8C15.3284 8 16 7.32843 16 6.5C16 5.67157 15.3284 5 14.5 5C13.6716 5 13 5.67157 13 6.5C13 7.32843 13.6716 8 14.5 8Z",
    className: "Icon__blendBackground",
    style: {
      fill: "var(--blendBackground)"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 2C1.79086 2 0 3.79086 0 6V26C0 28.2091 1.79086 30 4 30H32C34.2091 30 36 28.2091 36 26V6C36 3.79086 34.2091 2 32 2H4ZM4.5 8C5.32843 8 6 7.32843 6 6.5C6 5.67157 5.32843 5 4.5 5C3.67157 5 3 5.67157 3 6.5C3 7.32843 3.67157 8 4.5 8ZM11 6.5C11 7.32843 10.3284 8 9.5 8C8.67157 8 8 7.32843 8 6.5C8 5.67157 8.67157 5 9.5 5C10.3284 5 11 5.67157 11 6.5ZM14.5 8C15.3284 8 16 7.32843 16 6.5C16 5.67157 15.3284 5 14.5 5C13.6716 5 13 5.67157 13 6.5C13 7.32843 13.6716 8 14.5 8Z",
    className: "Icon__blendBackground",
    style: {},
    fill: "#00D4FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5573 17C24.2261 17 23.9341 17.2173 23.839 17.5345L18.289 36.0345C18.1446 36.5157 18.5049 37 19.0073 37H21.4413C21.7725 37 22.0645 36.7827 22.1597 36.4655L27.7097 17.9655C27.854 17.4843 27.4937 17 26.9913 17H24.5573ZM13.7428 19.7011C14.0238 19.3968 14.4983 19.3778 14.8026 19.6587L16.6396 21.3544C16.944 21.6354 16.963 22.1099 16.682 22.4142L12.443 27.0066L16.682 31.5989C16.963 31.9033 16.944 32.3778 16.6396 32.6587L14.8026 34.3544C14.4983 34.6354 14.0238 34.6164 13.7428 34.312L7.4689 27.5153C7.2037 27.228 7.20371 26.7852 7.4689 26.4979L13.7428 19.7011ZM32.2558 19.7011C31.9749 19.3968 31.5004 19.3778 31.196 19.6587L29.359 21.3544C29.0546 21.6354 29.0357 22.1099 29.3166 22.4142L33.5557 27.0066L29.3166 31.5989C29.0357 31.9033 29.0546 32.3778 29.359 32.6587L31.196 34.3544C31.5004 34.6354 31.9749 34.6164 32.2558 34.312L38.5297 27.5153C38.7949 27.228 38.7949 26.7852 38.5297 26.4979L32.2558 19.7011Z",
    className: "Icon__blendForeground",
    style: {},
    fill: "#7A73FF"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#BrowserWithCodeIconClipPath-)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5573 17C24.2261 17 23.9341 17.2173 23.839 17.5345L18.289 36.0345C18.1446 36.5157 18.5049 37 19.0073 37H21.4413C21.7725 37 22.0645 36.7827 22.1597 36.4655L27.7097 17.9655C27.854 17.4843 27.4937 17 26.9913 17H24.5573ZM13.7428 19.7011C14.0238 19.3968 14.4983 19.3778 14.8026 19.6587L16.6396 21.3544C16.944 21.6354 16.963 22.1099 16.682 22.4142L12.443 27.0066L16.682 31.5989C16.963 31.9033 16.944 32.3778 16.6396 32.6587L14.8026 34.3544C14.4983 34.6354 14.0238 34.6164 13.7428 34.312L7.4689 27.5153C7.2037 27.228 7.20371 26.7852 7.4689 26.4979L13.7428 19.7011ZM32.2558 19.7011C31.9749 19.3968 31.5004 19.3778 31.196 19.6587L29.359 21.3544C29.0546 21.6354 29.0357 22.1099 29.3166 22.4142L33.5557 27.0066L29.3166 31.5989C29.0357 31.9033 29.0546 32.3778 29.359 32.6587L31.196 34.3544C31.5004 34.6354 31.9749 34.6164 32.2558 34.312L38.5297 27.5153C38.7949 27.228 38.7949 26.7852 38.5297 26.4979L32.2558 19.7011Z",
    className: "Icon__blendForeground",
    style: {},
    fill: "#CCFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtml);
export default __webpack_public_path__ + "static/media/html.3c09d4cdc07171bbf2b4bec44e3de498.svg";
export { ForwardRef as ReactComponent };